import { instance } from '@/resource/axios'
import { cpsWithdrawalUrl, cpsDepositUrl } from './index'
import { Message } from 'element-ui'
import i18n from '@/lang/index'

/**
 * Request function with dynamic timeout
 * @param {Object} instance - Axios instance
 * @param {string} url - Full request URL
 * @param {string} method - HTTP method ('GET', 'POST', etc.)
 * @param {Object|null} data - Request body (used for POST)
 *  * @param {Object} [headers={}] - Custom headers for the request
 * @param {number|null} timeout - Timeout in milliseconds, or null for no timeout
 * @returns {Promise} - Returns the Axios response
 */
export const requestWithTimeout = async (url, method, data = null, headers = {}, timeout = null) => {
  try {
    const config = { method, url, headers }

    if (timeout) {
      config.timeout = timeout
    }

    if (method === 'POST') {
      config.data = data
    }

    const response = await instance.request(config)
    return response
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      Message({
        message: i18n.t('pcsPayment.timeoutMsg'),
        type: 'warning',
      })
    }
  }
}

export const apiChannelInfo = data => instance.post(`${cpsWithdrawalUrl}pcs/channel-info`, data)
export const apiCurrencyLimit = data => instance.post(`${cpsWithdrawalUrl}pcs/currency-limit`, data)
export const apiSortInfo = (data, timeout = 450000) =>
  requestWithTimeout(`${cpsWithdrawalUrl}pcs/v2/sort-info`, 'POST', data, {}, timeout)
export const apiPCSEnabled = data => instance.get(`${cpsWithdrawalUrl}pcs/enabled`)

/** Payment Center System Deposit */
export const apiPcsInitDeposit = (data, token, timeout = 450000) =>
  requestWithTimeout(`${cpsDepositUrl}init_deposit`, 'POST', data, { headers: { token: token } }, timeout)

export const apiPcsDynamicDomain = (data, token, timeout = 450000) =>
  requestWithTimeout(
    `${cpsDepositUrl}pcs/dynamic-domain`,
    'POST',
    data,
    { headers: { token } },
    timeout,
  )

export const apiPcsNotifyDomain = (data, token, timeout = 450000) =>
  requestWithTimeout(
    `${cpsDepositUrl}pcs/notify-domain`,
    'POST',
    data,
    { headers: { token } },
    timeout,
  )
